const PLACEHOLDER_CLIENT_ID = 'your_client_id';

/**
 * A client ID counts as configured only when it is a non-empty string that is
 * not the config template's placeholder. The server renders `null` when the
 * brand has no config at all, and an empty string or the placeholder when the
 * config file was never filled in.
 *
 * @param {unknown} clientId
 * @returns {boolean}
 */
export function isClientIdConfigured(clientId) {
	if (typeof clientId !== 'string') return false;
	const trimmed = clientId.trim();
	return trimmed !== '' && trimmed !== PLACEHOLDER_CLIENT_ID;
}

/**
 * @param {{google?: unknown, microsoft?: unknown}} clientIds
 * @returns {Array<'google'|'microsoft'>} Enabled providers, in display order.
 */
export function getEnabledProviders({ google, microsoft } = {}) {
	const enabled = [];
	if (isClientIdConfigured(google)) enabled.push('google');
	if (isClientIdConfigured(microsoft)) enabled.push('microsoft');
	return enabled;
}

/**
 * Reads the brand's client IDs from the server-rendered `window.serverData`.
 *
 * @param {object} [serverData]
 * @returns {{google: string|null, microsoft: string|null}}
 */
export function readOAuthClientIds(serverData = window.serverData) {
	return {
		google: serverData?.oauthGoogleClientId ?? null,
		microsoft: serverData?.oauthMicrosoftClientId ?? null
	};
}
